import { actions } from './action'

const initialState = {
  staffData: {
    membersList: [],
    totalCount: 0,
    allMembersList: [],
  },
  pagination: {
    skip: 0,
    limit: 10,
  },
  searchedEmp: null,
}
const staffState = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_STAFF_LIST:
      return {
        ...state,
        staffData: {
          membersList: action.payload.membersList,
          allMembersList: action.payload.allMembersList,
          totalCount: action.payload.totalCount,
        },
      }

    case actions.HANDLE_PAGINATION:
      return {
        ...state,
        pagination: action.payload,
      }
    case actions.HANDLE_EMPLOYEE_SEARCH:
      return {
        ...state,
        searchedEmp: action.payload,
      }

    default:
      return state
  }
}
export default staffState
